import { StrictMode } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import tokensCss from '@spezzial/brand-ui/tokens.css?inline';
import widgetCss from './styles.css?inline';
import { readConfig } from './lib/config';
import { App } from './App';

// <spezzial-ai-wrap> — bundled React widget embedded on the WP product page.
// Shadow DOM isolates it from the shop theme; brand tokens + component CSS are
// injected as `?inline` strings (the same approach as embed-map). Config arrives
// via data-* attributes (see class-product-embed.php).
class SpezzialAiWrap extends HTMLElement {
  #root: Root | null = null;

  connectedCallback(): void {
    if (this.#root) return;

    const shadow = this.attachShadow({ mode: 'open' });

    const style = document.createElement('style');
    style.textContent = `${tokensCss}\n${widgetCss}`;
    shadow.appendChild(style);

    const mount = document.createElement('div');
    mount.className = 'aiw-host';
    shadow.appendChild(mount);

    this.#root = createRoot(mount);
    this.#root.render(
      <StrictMode>
        <App config={readConfig(this)} />
      </StrictMode>,
    );
  }

  disconnectedCallback(): void {
    this.#root?.unmount();
    this.#root = null;
  }
}

if (!customElements.get('spezzial-ai-wrap')) {
  customElements.define('spezzial-ai-wrap', SpezzialAiWrap);
}
